import { useTranslation } from "react-i18next"

const Custom500: React.FC = () => {
  const { t } = useTranslation("general")

  return (
    <div className="container p-4">
      <h1 className="mb-4 text-center text-xl md:mb-12 md:text-4xl">
        {t("genericError")}
      </h1>
      <img
        className="h-40 w-full"
        src="/images/undraw_server_down.svg"
        alt=""
      />
    </div>
  )
}

export default Custom500
